"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagButtonOptions = void 0;

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core"); // Options used to create an edit button.


exports.tagButtonOptions = {
  icon: 'local_offer',
  label: 'Groups',
  groupLabel: 'Filter',
  name: 'Tag',
  renderForm: function renderForm(_a) {
    var ui = _a.ui,
        componentProps = _a.componentProps;

    var _b = core_1.getUI(ui),
        ComponentFormTitle = _b.ComponentFormTitle,
        ComponentFormLabel = _b.ComponentFormLabel,
        ComponentFormUnwrapButton = _b.ComponentFormUnwrapButton,
        ReactTags = _b.ReactTags;

    var _c = componentProps.getSuggestions,
        getSuggestions = _c === void 0 ? function () {
      return [];
    } : _c,
        _d = componentProps.placeholder,
        placeholder = _d === void 0 ? 'Select Tags' : _d,
        _e = componentProps.noSuggestionsText,
        noSuggestionsText = _e === void 0 ? 'No matching tags found.' : _e,
        _f = componentProps.minQueryLength,
        minQueryLength = _f === void 0 ? 1 : _f,
        _g = componentProps.allowNew,
        allowNew = _g === void 0 ? true : _g,
        _h = componentProps.allowMultipleTags,
        allowMultipleTags = _h === void 0 ? true : _h,
        _j = componentProps.inputAttributes,
        inputAttributes = _j === void 0 ? {
      name: 'react-tags-input'
    } : _j,
        _k = componentProps.formTitle,
        formTitle = _k === void 0 ? 'Tags' : _k,
        _l = componentProps.formBodyText,
        formBodyText = _l === void 0 ? 'Select from available tags:' : _l,
        _m = componentProps.seeAllText,
        seeAllText = _m === void 0 ? 'See all tags' : _m,
        _o = componentProps.autofocus,
        autofocus = _o === void 0 ? false : _o;
    var suggestions = getSuggestions();
    var context = core_1.useEditContext();

    var displayListOfTags = function displayListOfTags() {
      return context.showPageOverlay({
        message: suggestions.slice().reduce(function (acc, _tag) {
          return acc + "\n" + _tag.name;
        }, ''),
        hasSpinner: false,
        hasCloseButton: true
      });
    };

    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ComponentFormTitle, null, formTitle), react_1.default.createElement(ComponentFormLabel, null, formBodyText), react_1.default.createElement(ReactTags, {
      suggestions: suggestions,
      placeholder: placeholder,
      noSuggestionsText: noSuggestionsText,
      minQueryLength: minQueryLength,
      allowNew: allowNew,
      allowMultipleTags: allowMultipleTags,
      inputAttributes: inputAttributes,
      autofocus: autofocus
    }), react_1.default.createElement(ComponentFormUnwrapButton, {
      type: "button",
      onClick: displayListOfTags
    }, seeAllText));
  },
  global: false,
  local: true
};

var withRegisteredTags = function withRegisteredTags(Component) {
  return function (props) {
    var registerSuggestions = props.registerSuggestions;
    var componentData = core_1.useNodeDataHandlers().componentData;

    if (!lodash_1.isEmpty(componentData) && componentData.tags) {
      registerSuggestions(__spreadArrays(componentData.tags));
    }

    return react_1.default.createElement(Component, __assign({}, props));
  };
};

var withTagButton = lodash_1.flow(core_1.withEditButton(exports.tagButtonOptions), withRegisteredTags);
exports.default = withTagButton;